module.exports = __webpack_public_path__ + "dd216636862926134f32a54b32300b3a.png";